let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fayjw")).then(() => parcelRequire('6d4D9'));